import LogRocket from '../../util/getLogRocket';

export const defaultErrorHandler = errorBoundaryName => err => {
  LogRocket.captureException(err, {
    extra: {
      errorBoundaryName,
    },
  });
};
